import { useEffect, useState } from 'react';

type IRecaptchaType = [() => Promise<unknown>, boolean];

export const useRecaptcha = (action: string): IRecaptchaType => {
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement('script');
    script.src =
      'https://www.google.com/recaptcha/api.js?render=6Ld5ONgZAAAAADa9f_KnMMNupD1oi0TvuIj1mTVC';
    script.addEventListener('load', handleLoaded);
    document.body.appendChild(script);
  }, []);

  const handleLoaded = (event: Event): any => setScriptLoaded(true);

  const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
      (window as any).grecaptcha.ready(function () {
        (window as any).grecaptcha
          .execute('6Ld5ONgZAAAAADa9f_KnMMNupD1oi0TvuIj1mTVC', {
            action,
          })
          .then(function (token: string) {
            return resolve(token);
          });
      });
    });
  };

  return [getRecaptchaToken, scriptLoaded];
};
